// Listener represents event listener.

// EventBus is a simple non cohesive event bus contract.

class EventBusImpl {
  listeners = {};
  subscribe(name, l) {
    if (!this.listeners[name]) {
      this.listeners[name] = [];
    }
    this.listeners[name].push(l);
  }
  unsubscribe(name, l) {
    if (!this.listeners[name]) {
      return;
    }
    this.listeners[name] = this.listeners[name].filter(item => item !== l);
  }
  publish(name, d) {
    const listnrs = this.listeners[name] ?? [];

    // TODO should run as promises to introduce async behavior?
    listnrs.forEach(l => l(name, d));
  }
}
const eventBus = new EventBusImpl();

// export singleton.
export default eventBus;
//# sourceMappingURL=index.js.map